import * as React from 'react'
import _ from 'lodash'

import ColorPickerButton from '../shared/ColorPickerButton'

export type WidgetCustomColorsProps = {
    customization: Api.WebCodeCustomization
    resetColors: (e: React.MouseEvent<HTMLElement>) => void
    updateCustomColor: (groupKey: string, colorKey: string, newColor: string) => void
}

export type WidgetCustomColorsState = {}

export default class WidgetCustomColors extends React.Component<WidgetCustomColorsProps, WidgetCustomColorsState> {
    render() {
        const { customization, resetColors, updateCustomColor } = this.props
        const widgetCustomization = customization.widget
        const apiWidgetColors = widgetCustomization && widgetCustomization.colors
        const headerBg = apiWidgetColors && apiWidgetColors.header_background
        const headerText = apiWidgetColors && apiWidgetColors.header_text
        const agentBg = apiWidgetColors && apiWidgetColors.agent_background
        const agentText = apiWidgetColors && apiWidgetColors.agent_text
        const visitorBg = apiWidgetColors && apiWidgetColors.visitor_background
        const visitorText = apiWidgetColors && apiWidgetColors.visitor_text

        const customizationOptions = {
            widgetColors: {
                header: {
                    background: {
                        value: 'Header & Footer Background',
                        color: headerBg || '#303030',
                    },
                    text: {
                        value: 'Header & Footer Text',
                        color: headerText || '#ffffff',
                    },
                },
                agent: {
                    background: {
                        value: 'Agent Message Background',
                        color: agentBg || '#174a8e',
                    },
                    text: {
                        value: 'Agent Message Text',
                        color: agentText || '#ffffff',
                    },
                },
                visitor: {
                    background: {
                        value: 'Visitor Message Background',
                        color: visitorBg || '#ffffff',
                    },
                    text: {
                        value: 'Visitor Message Text',
                        color: visitorText || '#4a4a4a',
                    },
                },
            },
        }

        const widgetColorGroups = customizationOptions.widgetColors as Record<
            string,
            Record<string, { color: string; value: string }>
        >
        const colorButtons = _.flatten(
            Object.keys(widgetColorGroups).map(groupKey => {
                return Object.keys(widgetColorGroups[groupKey]).map(colorKey => {
                    const colorReference = widgetColorGroups[groupKey][colorKey]
                    return { groupKey, colorKey, color: colorReference.color, value: colorReference.value }
                })
            }),
        )

        return (
            <div className="widget-colors">
                <h3>Colors:</h3>
                {colorButtons.map(customButton => {
                    const id = `custom-${customButton.groupKey}-${customButton.colorKey}`
                    const bindUpdate = updateCustomColor.bind(this, customButton.groupKey, customButton.colorKey)
                    return (
                        <ColorPickerButton
                            key={id}
                            color={customButton.color}
                            id={id}
                            label={customButton.value}
                            updateCustomColor={bindUpdate}
                        />
                    )
                })}
                <a onClick={resetColors} className="customize-widget__reset-colors" href="/#">
                    Reset colors to default
                </a>
            </div>
        )
    }
}
